import { SurveyOption } from '@/api';
import CheckboxChecked from '@/assets/icons/checkbox-checked.svg';
import CheckboxUnchecked from '@/assets/icons/checkbox-unchecked.svg';

const triggerHaptic = (type: 'light' | 'medium' | 'heavy' = 'light') => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ triggerHaptic: type }));
  }
};

interface CheckboxQuestionProps {
  questionId: number;
  options: SurveyOption[];
  value: string[] | undefined;
  onChange: (questionId: number, value: string, checked: boolean) => void;
}

const CheckboxQuestion = ({ questionId, options, value, onChange }: CheckboxQuestionProps) => {
  // 디자인 스펙 기준: min-width 300px
  const minWidth = 300;

  const handleChange = (optionId: number, checked: boolean) => {
    triggerHaptic('light');
    onChange(questionId, String(optionId), checked);
  };

  return (
    <div
      className="grid gap-[10px]"
      style={{
        gridTemplateColumns: `repeat(auto-fit, minmax(${minWidth}px, 1fr))`,
      }}
    >
      {options.map((option) => {
        const isSelected = Array.isArray(value) && value.includes(String(option.optionId));
        return (
          <label
            key={option.optionId}
            className={`flex w-full cursor-pointer items-center justify-start gap-[6px] rounded-[10px] border border-[#111111] px-[14px] py-[14px] transition-colors ${
              isSelected ? 'bg-[#D0FFEB]' : 'bg-white hover:bg-[#EFEFEF]'
            }`}
          >
            <input
              type="checkbox"
              value={option.optionId}
              checked={isSelected}
              onChange={(e) => handleChange(option.optionId, e.target.checked)}
              className="hidden"
            />
            <img
              src={isSelected ? CheckboxChecked : CheckboxUnchecked}
              alt=""
              className="h-[18px] w-[18px] shrink-0"
            />
            <span className="font-Pretendard text-[15px] font-semibold leading-[90%] tracking-normal text-[#111111] break-words text-left">
              {option.optionText}
            </span>
          </label>
        );
      })}
    </div>
  );
};

export default CheckboxQuestion;